import { curry, compose, and, includes, cond, T, always } from 'ramda';
import detectOpponent from './detectOpponent.js';
import _detectPiece from './detectPiece.js';
import _removeDirection from './removeDirection.js';

function detectEnemyOnTiles(e,t,o,c){return compose(and(detectOpponent(t,o)),includes(c),cond([[_detectPiece.Pawn,_removeDirection.Vertical(e)],[T,always(e)]]))(t)}var detectEnemyOnTiles$1 = curry(detectEnemyOnTiles);

export { detectEnemyOnTiles$1 as default };
//# sourceMappingURL=detectEnemyOnTiles.js.map
